module.exports = __webpack_public_path__ + "static/squiggle-left-610001555612aa4ea35300412f0c5720.png";